import { ProjectTable } from "./projectTable";

export default ProjectTable;